module.exports = __webpack_public_path__ + "img/A1-h-title.c127f48f.png";